const errorsTrads = {
  email: 'components.Input.error.validation.email',
  json: 'components.Input.error.validation.json',
  lowercase: 'components.Input.error.validation.lowercase',
  max: 'components.Input.error.validation.max',
  maxLength: 'components.Input.error.validation.maxLength',
  min: 'components.Input.error.validation.min',
  minLength: 'components.Input.error.validation.minLength',
  regex: 'components.Input.error.validation.regex',
  required: 'components.Input.error.validation.required',
  unique: 'components.Input.error.validation.unique',
  integer: 'component.Input.error.validation.integer',
};

export { errorsTrads as translatedErrors };
